<template>
  <div class="correios-plp">
    <table style="width: 100%">
      <tr>
        <td style="width: 10em">
          <img src="/images/shipment/correios/logo-negativo.jpg" style="width: 8em;height: auto;display: block;">
        </td>
        <td class="correios-plp-header">
          <strong>EMPRESA BRASILEIRA DE CORREIOS E TELÉGRAFOS</strong>
        </td>
      </tr>
      <tr><td colspan="2" style="padding-top: .5em">
        <table style="width: 100%; border: 1px solid #000">
          <tr style="border: 1px solid #000">
            <td class="correios-plp-title">
              <strong>PRÉ - LISTA DE POSTAGEM - PLP - SIGEP WEB</strong>
            </td>
          </tr>
          <tr style="border: 1px solid #000">
            <td style="padding: .3em">
              <table style="width: 100%">
                <tr>
                  <td>
                    <p class="correios-plp-subheader"><strong>SIGEP WEB - Gerenciador de Postagens dos Correios</strong></p>
                  </td>
                  <td style="text-align: center; width: 20em; font-size: 11pt">
                    <p style="margin: 0"><strong>Nº PLP: </strong> {{ authorizationCode }}</p>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: top">
                    <p style="font-size: 11pt; margin: 0"><strong>Contrato: </strong>{{ contract }}</p>
                    <p style="font-size: 11pt; margin: 0"><strong>Cliente: </strong> {{ company }}</p>
                  </td>
                  <td style="text-align: center; width: 17em">
                    <canvas class="barcode"
                       :data-value="authorizationCode"
                       data-height="40"
                       data-margin="0"
                       data-font="arial"
                       data-displayvalue="false">
                    </canvas>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="border: 1px solid #000; font-size: 9pt">
            <td style="padding: .3em">
              <table style="width: 100%">
                <tr>
                  <td>
                    <p style="margin: 0"><strong>Quantidade:</strong></p>
                  </td>
                  <td style="width: 25em">
                    <p style="margin: 0"><strong>Serviço:</strong></p>
                  </td>
                  <td style="text-align: center; width: 26.6em">
                    <p style="margin: 0"><strong>Data da entrega: ____/____/________</strong></p>
                  </td>
                </tr>
                <tr v-for="(service,index) in services" :key="index">
                  <td>
                    <p class="quantity" style="text-align: left; margin: 0 0 0 2.9em">
                      {{ service.quantity }}
                    </p>
                  </td>
                  <td colspan="2" style="width: 51.6em">
                    <p style="margin: 0">{{ service.code }} - {{ service.name }}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p style="margin: 0"><strong>Total: </strong>{{ total }}</p>
                  </td>
                  <td style="text-align: center; width: 26.6em">
                    <p style="margin: 0">
                      <strong>_______________________________<br>Assinatura / Matrícula dos Correios</strong>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td></tr>
      <tr><td colspan="2" style="font-size: 9pt; text-align: right; padding-right: 5em">1a via - Correios</td></tr>
    </table>

    <div style="border-bottom: 2px dashed #444; margin: .3em .3em .6em"></div>

    <table style="width: 100%">
      <tr>
        <td style="width: 10em">
          <img src="/images/shipment/correios/logo-negativo.jpg" style="width: 8em;height: auto;display: block;">
        </td>
        <td class="correios-plp-header">
          <strong>EMPRESA BRASILEIRA DE CORREIOS E TELÉGRAFOS</strong>
        </td>
      </tr>
      <tr><td colspan="2" style="padding-top: .5em">
        <table style="width: 100%; border: 1px solid #000">
          <tr style="border: 1px solid #000">
            <td class="correios-plp-title">
              <strong>PRÉ - LISTA DE POSTAGEM - PLP - SIGEP WEB</strong>
            </td>
          </tr>
          <tr style="border: 1px solid #000">
            <td style="padding: .3em">
              <table style="width: 100%">
                <tr>
                  <td>
                    <p class="correios-plp-subheader"><strong>SIGEP WEB - Gerenciador de Postagens dos Correios</strong></p>
                  </td>
                  <td style="text-align: center; width: 20em; font-size: 11pt">
                    <p style="margin: 0"><strong>Nº PLP: </strong> {{ authorizationCode }}</p>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: top">
                    <p style="font-size: 11pt; margin: 0"><strong>Contrato: </strong>{{ contract }}</p>
                    <p style="font-size: 11pt; margin: 0"><strong>Cliente: </strong> {{ company }}</p>
                  </td>
                  <td style="text-align: center; width: 17em">
                    <canvas class="barcode"
                      :data-value="authorizationCode"
                      data-height="40"
                      data-margin="0"
                      data-font="arial"
                      data-displayvalue="false">
                    </canvas>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="border: 1px solid #000; font-size: 9pt">
            <td style="padding: .3em">
              <table style="width: 100%">
                <tr>
                  <td>
                    <p style="margin: 0"><strong>Quantidade:</strong></p>
                  </td>
                  <td style="width: 25em">
                    <p style="margin: 0"><strong>Serviço:</strong></p>
                  </td>
                  <td style="text-align: center; width: 26.6em">
                    <p style="margin: 0"><strong>Data da entrega: ____/____/________</strong></p>
                  </td>
                </tr>
                <tr v-for="(service, index) in services" :key="index">
                  <td>
                    <p class="quantity" style="text-align: left; margin: 0 0 0 2.9em">
                      {{ service.quantity }}
                    </p>
                  </td>
                  <td colspan="2" style="width: 51.6em">
                    <p style="margin: 0">{{ service.code }} - {{ service.name }}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p style="margin: 0"><strong>Total: </strong>{{ total }}</p>
                  </td>
                  <td style="text-align: center; width: 26.6em">
                    <p style="margin: 0">
                      <strong>_______________________________<br>Assinatura / Matrícula dos Correios</strong>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td></tr>
      <tr><td colspan="2" style="font-size: 9pt; text-align: right; padding-right: 5.3em">2a via - Cliente</td></tr>
    </table>
  </div>
</template>

<script>
  import { comma } from 'commons/js/RegExp';
  export default {
    props: {
      contract: {
        type: String,
        required: true
      },
      authorizationCode: {
        type: String,
        required: true
      },
      serviceCodes: {
        type: String,
        required: true
      },
      serviceNames: {
        type: Object,
        required: true
      }
    },

    computed: {
      company: function () {
        return 'MELHOR ENVIO';
      },

      serviceCodesArray() {
        return this.serviceCodes.split(comma());
      },

      serviceCodesCounter() {
        const codes = {};

        this.serviceCodesArray.forEach((code) => {
          if (!codes[code]) {
            codes[code] = 0;
          }
          codes[code]++;
        });

        return codes;
      },

      services() {
        return Object.keys(this.serviceCodesCounter).map(code => ({
          code: code,
          name: this.serviceNames[code],
          quantity: this.serviceCodesCounter[code],
        }));
      },

      total() {
        return this.serviceCodesArray.length;
      },
    },

    filters: {
      phone(value) {
        if (!value) {
            return '';
        }
        return String(value).replace(/(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
      }
    },

    mounted() {
      BarCode('.barcode').init();
    }
  }
</script>

<style lang="stylus" scoped>
.correios-plp
  color #000
  font-size 12pt
  font-family Arial
  overflow hidden
  .correios-plp-header
    font-size 15pt
    text-align center
    vertical-align bottom
  .correios-plp-title
    font-size 15pt
    text-align center
    padding 5px
  .correios-plp-subheader
    margin 0
    font-size 11pt
  strong
    font-weight bold

@media print
  .correios-plp
    padding 5mm !important
    margin-top 1mm !important
    width 90%
    margin 0 auto

    .correios-plp-header
      font-size 11pt
      text-align center
      vertical-align middle

    .correios-plp-title
      font-size 11pt
      text-align center
      padding 5px

    .correios-plp-subheader
      margin 0
      font-size 9pt
</style>
